import { Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TablePagination from "@material-ui/core/TablePagination";
import React from "react";
import { Test } from "../../graphql/baseTypes";
import { generateLongIdFromTest } from "../../utils/tests";
import Loader from "../Loading/Loader";
import EnhancedTableHead, { columns } from "./EnhancedTableHead";
import EnhancedTableToolbar from "./EnhancedTableToolBar";
import TestTableItem from "./TestTableItem";

interface Props {
  tests: Array<Test>;
  rowsPerPage: number;
  page: number;
  loading?: boolean;
  selected?: Array<string>;
  onClickItem: (id: string) => any;
  onSelectItem: (event: React.MouseEvent<any>, id: string) => any;
  handleChangePage: (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => void;
  handleChangeRowsPerPage?: React.ChangeEventHandler<
    HTMLTextAreaElement | HTMLInputElement
  >;
  totaltests?: number;
  handleSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onSendMailToSelected: () => any;
}
const useStyles = makeStyles({
  root: {
    marginTop: 20,
    width: "100%",
  },
  container: {
    maxHeight: 510,
  },
  empty: {
    margin: "40px 0",
  },
});

const TestTable: React.FC<Props> = ({
  tests,
  handleChangeRowsPerPage,
  handleChangePage,
  page,
  rowsPerPage,
  loading,
  totaltests = 0,
  selected = [],
  handleSelectAllClick,
  onSelectItem,
  onClickItem,
  onSendMailToSelected,
}) => {
  const classes = useStyles();
  const isSelected = (name: string) => selected.indexOf(name) !== -1;

  return (
    <Paper className={classes.root}>
      {selected.length > 0 && (
        <EnhancedTableToolbar
          numSelected={selected.length}
          selected={selected}
          onSendMailToSelected={onSendMailToSelected}
          tests={tests}
        />
      )}

      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <EnhancedTableHead
            numSelected={selected.length}
            onSelectAllClick={handleSelectAllClick}
            rowCount={tests.length}
          />

          <TableBody>
            {!loading &&
              tests.map((row, index) => {
                const KEY = generateLongIdFromTest(row);
                const isItemSelected = isSelected(KEY);
                const labelId = `enhanced-table-checkbox-${index}`;

                return (
                  <TestTableItem
                    key={KEY}
                    item={row}
                    columns={columns}
                    handleClick={onSelectItem}
                    isItemSelected={isItemSelected}
                    labelId={labelId}
                    onClickItem={onClickItem}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      {loading && <Loader />}

      {tests.length === 0 && !loading && (
        <Typography
          align="center"
          variant="subtitle1"
          className={classes.empty}
        >
          Keine Tests gefunden
        </Typography>
      )}
      <TablePagination
        rowsPerPageOptions={[25, 100, 200]}
        component="div"
        count={totaltests}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
};

export default TestTable;
